export default __webpack_public_path__ + "static/media/illustration.72cf7f2a.webp";